import React                   from 'react'
import i18n from '../../../i18n';
import ApplicationItem from "./ApplicationItem";

export default (props) => {
  const { applications, toggleDelete } = props;

  return (
    <div className="col-sm-12 content-body">
      <table className="table">
        <thead>
        <tr>
          <th scope="col" className="text-left">{i18n.t('application.tbl_header_name')}</th>
          <th scope="col" className="text-right"> </th>
        </tr>
        </thead>
        <tbody>
        {applications.map(application => {
          return <ApplicationItem key={application.id}
                                  application={application}
                                  toggleDelete={toggleDelete}
          />
        })}
        </tbody>
      </table>
    </div>
  )
}
